import { FC, useState } from 'react'
import { IcArrowRight } from '@healingpaper/cell-icons'
import { DoctorForUser } from 'api-client/contracts/doctor'
import { Typography } from '@healingpaper/cell'

import Section from '@/components/atomic/molecules/Section'
import { BlockButton } from '@/components/atomic/molecules/StyledButton'
import DoctorList from '@/features/hospital/components/doctor-list'
import { useTranslation } from '@/lang'
import theme from '@/theme'

// 스타일 컴포넌트는 hospital-badge-section.tsx와 중복 정의를 피하기 위해 export해서 사용하거나, 이 파일에서만 쓸 경우 재정의

// MAX_DOCTOR_LENGTH 상수는 필요에 따라 이 파일에서만 사용
const MAX_DOCTOR_LENGTH = 4

// DoctorSection 컴포넌트의 props 타입 정의
interface DoctorSectionProps {
  user: { id?: number } | null
  doctors: DoctorForUser[]
  onClickMoreList?: (target: string) => void
  emitDoctorClickedWithEvent: (args: {
    doctorId: number
    hospitalId: number
    userId: number
    orderProperty: { placementOrderInPage: number; itemOrderInPlacement: number }
  }) => void
  emitDoctorViewedWithEvent: (args: {
    doctorId: number
    hospitalId: number
    userId: number
    orderProperty: { placementOrderInPage: number; itemOrderInPlacement: number }
  }) => void
  hospitalId: number
}

/**
 * 의사 리스트 섹션 컴포넌트
 */
const DOCTOR_SECTION_INDEX = 4

export const DoctorSection: FC<DoctorSectionProps> = ({
  user,
  doctors,
  onClickMoreList,
  emitDoctorClickedWithEvent,
  emitDoctorViewedWithEvent,
  hospitalId,
}) => {
  const { t } = useTranslation()
  const [showAllDoctors, setShowAllDoctors] = useState(false)

  if (!doctors.length) return null

  const handleClickMoreList = () => {
    setShowAllDoctors(true)
    if (onClickMoreList) {
      onClickMoreList('doctor')
    }
  }

  return (
    <>
      <div style={{ padding: '26px 26px 0' }}>
        <Typography type="title3" elementType="h2" aria-label="doctor-section-header">
          {t('templates.hospitalDetail.doctorTitle')}{' '}
          <span style={{ color: theme.colors.orange }}>{doctors.length.toLocaleString()}</span>
          {t('templates.hospitalDetail.countUnit')}
        </Typography>
      </div>
      <Section
        bottomComponent={
          doctors.length > MAX_DOCTOR_LENGTH &&
          !showAllDoctors && (
            <BlockButton color="tertiary" size="medium" onClick={handleClickMoreList} className="w-full mt-4">
              {`${t('templates.hospitalDetail.buttons.allDoctor')}`}
              <IcArrowRight width={16} height={16} />
            </BlockButton>
          )
        }
      >
        <DoctorList
          doctors={showAllDoctors ? doctors : doctors.slice(0, MAX_DOCTOR_LENGTH)}
          defaultText={{
            ceo: t('templates.hospitalDetail.doctor.ceo'),
            doctor: t('templates.hospitalDetail.doctor.doctor'),
            review: t('templates.hospitalDetail.doctor.review'),
          }}
          onClickDoctorProfile={(index) => {
            const doctorIndex = showAllDoctors ? index : index
            !!user?.id &&
              emitDoctorClickedWithEvent({
                doctorId: doctors[doctorIndex].doctorId,
                hospitalId,
                userId: user.id,
                orderProperty: {
                  placementOrderInPage: DOCTOR_SECTION_INDEX,
                  itemOrderInPlacement: index + 1,
                },
              })
          }}
          isDoctorImpressionTrackerActive={!!user?.id}
          onDoctorImpressed={(index) => {
            const doctorIndex = showAllDoctors ? index : index
            !!user?.id &&
              emitDoctorViewedWithEvent({
                doctorId: doctors[doctorIndex].doctorId,
                hospitalId,
                userId: user.id,
                orderProperty: {
                  placementOrderInPage: DOCTOR_SECTION_INDEX,
                  itemOrderInPlacement: index + 1,
                },
              })
          }}
        />
      </Section>
    </>
  )
}
